export const LANGS = ["en", "el"];
export const DEFAULT_LANG = "en";

export const dict = {
    en: {
        nav: {
            industries: "Industries",
            services: "Services",
            pricing: "Pricing",
            work: "Work",
            contact: "Contact",
            letsTalk: "Let's Talk",
        },
        hero: {
            badge: "FTAKLAKIS MEDIA · Premium Content Studio",
            location: "Athens · Worldwide",
            line1: "Premium content",
            line2Pre: "that ",
            line2Accent: "grows",
            line3: "businesses.",
            subtitle: {
                pre: "Social media, podcasts, drone films and cinematic video — built by ",
                a: "one premium studio",
                sep1: "",
                b: "",
                sep2: "",
                c: "",
                sep3: "",
                d: "",
                sep4: "",
                e: "",
                post: ".",
            },
            ctaPrimary: "Start a Project",
            ctaSecondary: "View Portfolio",
            stats: [
                { k: "250+", v: "Podcast Productions" },
                { k: "Multi-Industry", v: "Content Creation" },
                { k: "4K", v: "Cinema Quality" },
                { k: "Same-Day", v: "Response" },
            ],
        },
        marquee: [
            "CINEMATIC CONTENT",
            "SOCIAL MEDIA",
            "DRONE FILMS",
            "PODCAST PRODUCTION",
            "SHORT FORM CONTENT",
            "BRAND STORYTELLING",
        ],
        ourServices: {
            eyebrow: "Our Services",
            titlePre: "Everything you need to ",
            titleAccent: "grow",
            titlePost: ", in one studio.",
            lede: "Six capabilities, one monthly system.",
            explore: "Explore",
            cards: [
                {
                    title: "Social Media Management",
                    body: "Strategy, content and publishing built to grow your presence and turn attention into customers.",
                },
                {
                    title: "Short Form Content",
                    body: "Reels, TikToks and Shorts engineered for the algorithm — designed to convert scrolls into followers.",
                },
                {
                    title: "Podcast Production",
                    body: "Studio-grade multi-cam shows engineered for authority — from concept to distribution.",
                },
                {
                    title: "Drone Videography",
                    body: "Certified aerial cinematography for hospitality, real estate and premium brand films.",
                },
                {
                    title: "Commercial Video Production",
                    body: "Full-service cinematic productions — from creative direction to on-set filming and delivery.",
                },
                {
                    title: "Video Editing",
                    body: "Story-first edits with cinematic color, sound design and motion — held to cinema standard.",
                },
            ],
        },
        industries: {
            eyebrow: "Built For Your Business",
            titlePre: "Content that brings ",
            titleAccent: "real customers",
            titlePost: " through your door.",
            lede: "Premium content, made for the businesses that need to look global.",
            footerLead:
                "Not on the list? We work with premium brands across every industry.",
            footerCta: "Tell us about your business →",
            cards: [
                {
                    title: "Hotels",
                    promise: "More direct bookings.",
                    line: "Cinematic hotel films that turn scrolls into stays.",
                },
                {
                    title: "Restaurants",
                    promise: "Fuller tables, every week.",
                    line: "Signature food & atmosphere content that fills reservations.",
                },
                {
                    title: "Gyms & Studios",
                    promise: "More sign-ups, less churn.",
                    line: "High-energy reels that showcase your community and results.",
                },
                {
                    title: "Real Estate",
                    promise: "Faster closings.",
                    line: "Property tours & drone films that sell before the viewing.",
                },
                {
                    title: "Luxury Villas",
                    promise: "Premium guests, premium rates.",
                    line: "Editorial films that position your villa as a destination.",
                },
                {
                    title: "Professional Services",
                    promise: "Trust that converts.",
                    line: "Elegant content for law firms, accounting offices, consultants, architects, financial advisors and private offices — building authority and client confidence.",
                },
            ],
            seePlans: "See plans",
        },
        about: {
            eyebrow: "Why Businesses Choose Us",
            titlePre: "Founded by ",
            titleName: "Kostas Ftaklakis",
            titleMid:
                " — a Greek media studio helping local businesses become the ",
            titleAccent: "obvious premium choice",
            titlePost: ".",
            chapter: "Chapter",
            chapters: [
                {
                    title: "Content built to sell.",
                    body: "We don't chase trends. Every video, edit and campaign is engineered to turn attention into bookings, reservations, memberships and closings for your business.",
                },
                {
                    title: "A brand people trust.",
                    body: "In hospitality, real estate, health and premium services, trust is everything. Our cinematic craft signals quality — so guests, patients and clients choose you first.",
                },
                {
                    title: "A monthly system, not a one-off.",
                    body: "Real growth comes from consistency. We plug into your business as a full media partner — planned, produced and delivered on time, every month.",
                },
            ],
        },
        services: {
            eyebrow: "Services · 05",
            titlePre: "Five disciplines. ",
            titleAccent: "One studio.",
            lede: "Every service, delivered to cinema standard.",
            seePlans: "See plans",
            cards: [
                {
                    title: "Social Media Management",
                    tag: "Presence",
                    body: "A monthly system that grows your presence, positions your brand and turns attention into customers.",
                    deliverables: [
                        "Content strategy & pillars",
                        "Short-form production",
                        "Publishing & community",
                        "Monthly performance report",
                    ],
                },
                {
                    title: "Podcast Production",
                    tag: "Authority",
                    body: "Studio-grade shows engineered for authority — from concept and multi-cam capture to distribution and social clips.",
                    deliverables: [
                        "Concept & format design",
                        "Multi-cam studio capture",
                        "Full episode edit + audio",
                        "Short-form cutdowns",
                    ],
                },
                {
                    title: "Video Editing",
                    tag: "Craft",
                    body: "Story-first edits with cinematic color, sound design and motion typography. Made to hold attention from second one.",
                    deliverables: [
                        "Story-first cuts",
                        "Cinematic color grade",
                        "Sound design & music",
                        "Motion typography",
                    ],
                },
                {
                    title: "Drone Videography",
                    tag: "Perspective",
                    body: "Certified aerial cinematography for hospitality, real estate and brand films. Cinematic altitude, controlled precision.",
                    deliverables: [
                        "Location scouting",
                        "Certified pilot & 4K cine",
                        "Color-graded delivery",
                        "Vertical & horizontal cuts",
                    ],
                },
                {
                    title: "Organic Content Creation",
                    tag: "Signature",
                    body: "Full-service cinematic productions — from creative direction and pre-production to on-set filming and finished delivery.",
                    deliverables: [
                        "Short-form Videos",
                        "Long-form Videos",
                        "Instagram Reels",
                        "TikTok Content",
                        "YouTube Content",
                        "Brand Storytelling",
                    ],
                },
            ],
        },
        why: {
            eyebrow: "Why Businesses Work With Us",
            titlePre: "Four reasons brands ",
            titleAccent: "stay with us",
            titlePost: ".",
            lede: "Not a marketing agency — a production partner obsessed with craft.",
            cards: [
                {
                    title: "Premium Cinematic Content",
                    body: "Every video is directed, shot and graded to cinema standard. Content that instantly signals a premium brand.",
                },
                {
                    title: "Fast Monthly Delivery",
                    body: "A dependable production system that ships on time, every month — so your marketing never runs out of fuel.",
                },
                {
                    title: "Social Media Growth",
                    body: "Content engineered for the algorithm — short-form built to convert scrolls into followers, bookings and customers.",
                },
                {
                    title: "Long-Term Partnership",
                    body: "We work as your in-house media team. One strategy, one voice, one partner — for the long run.",
                },
            ],
        },
        pricing: {
            eyebrow: "Business Social Media Management · 03",
            titlePre: "Business ",
            titleAccent: "Social Media Management",
            titlePost: " Packages.",
            lede: "Consistent monthly content and social media growth. Every other service is custom-quoted.",
            perMonth: "/ month",
            vat: "+ VAT",
            plan: "Plan",
            mostPopular: "Most Popular",
            custom: {
                eyebrow: "Every Other Service",
                titlePre: "Request a ",
                titleAccent: "Custom Quote",
                body: "Podcast Production, Professional Video Editing, Drone Videography, High-End Commercial Video Production, Content Strategy, Personal Branding and Photography are all custom-scoped and quoted based on your project's requirements.",
                servicesLabel: "Custom-quoted services",
                services: [
                    "Podcast Production",
                    "Professional Video Editing",
                    "Drone Videography",
                    "High-End Commercial Video Production",
                    "Content Strategy",
                    "Personal Branding",
                    "Photography",
                ],
                cta: "Book a Discovery Call",
            },
            plans: [
                {
                    name: "Starter",
                    tag: "For new brands",
                    videos: "15 Videos",
                    features: [
                        "15 short-form videos per month",
                        "Full editing & sound design",
                        "Cinematic color grade",
                        "Ready for Reels, TikTok, Shorts",
                        "Monthly performance report",
                    ],
                    cta: "Start with Starter",
                },
                {
                    name: "Growth",
                    tag: "Most popular",
                    videos: "30 Videos",
                    features: [
                        "30 short-form videos per month",
                        "Priority production slots",
                        "Advanced editing & motion",
                        "Content strategy & pillars",
                        "Bi-weekly review call",
                    ],
                    cta: "Choose Growth",
                },
                {
                    name: "Scale",
                    tag: "For serious brands",
                    videos: "90 Videos",
                    bonus: "Includes 30 bonus videos",
                    is3Month: true,
                    periodNote: "3-month package",
                    features: [
                        "90 short-form videos per month",
                        "30 bonus videos included",
                        "Dedicated editor & producer",
                        "Full content system & calendar",
                        "Weekly strategy call",
                    ],
                    cta: "Scale with us",
                },
            ],
        },
        portfolio: {
            eyebrow: "Selected Work",
            titlePre: "Recent ",
            titleAccent: "films",
            titlePost: ".",
            cta: "Start a project",
            uploadMedia: "Upload Media",
            editableNote: {
                title: "More work landing here soon",
                body: "New client projects, podcast productions, drone footage and cinematic brand films — added as they wrap.",
            },
            categories: {
                All: "All",
                Podcast: "Podcast",
                Drone: "Drone",
                Business: "Business",
            },
            items: {
                "podcast-photo": {
                    title: "Podcast · Photo",
                    meta: "Studio photography · Coming Soon",
                },
                "drone-footage": {
                    title: "Hospitality Aerial Film",
                    meta: "Drone · 4K · Cinematic",
                },
                "business-video": {
                    title: "Retail Brand Film",
                    meta: "Commercial · Brand Storytelling",
                },
            },
        },
        cta: {
            eyebrow: "Ready when you are",
            titlePre: "Let's ",
            titleAccent: "grow",
            titlePost: " your brand",
            sub: {
                pre: "Premium content that brings ",
                a: "attention",
                sep1: ", ",
                b: "trust",
                and: " and ",
                c: "customers",
                post: ".",
            },
            primary: "Start a project",
            secondary: "View plans",
            location: "Booking select projects · Athens · Worldwide",
        },
        contact: {
            eyebrow: "Contact · Available Now",
            titlePre: "Let's ",
            titleAccent: "Talk",
            subtitle: {
                pre: "Whether you're a ",
                a: "restaurant",
                sep1: ", ",
                b: "hotel",
                sep2: ", ",
                c: "gym",
                sep3: ", ",
                d: "real estate agency",
                and: " or ",
                e: "local business",
                post: " — we create premium content that helps you attract more customers.",
            },
            labels: {
                direct: "Direct",
                based: "Based",
                response: "Response",
                location: "Athens · Greece",
                worldwide: "Working worldwide",
                within: "Same-Day",
            },
            channels: {
                WhatsApp: "WhatsApp",
                Email: "Email",
                Instagram: "Instagram",
                YouTube: "YouTube",
                TikTok: "TikTok",
                Facebook: "Facebook",
                LinkedIn: "LinkedIn",
                Viber: "Viber",
            },
        },
        follow: {
            eyebrow: "Follow Me",
            titlePre: "Stay close to the ",
            titleAccent: "studio",
            titlePost: ".",
            lede: "Behind-the-scenes, new work drops and cinematic moments — right from the studio floor.",
        },
        speaking: {
            eyebrow: "Meet Ftaklakis Media",
            titlePre: "Meet ",
            titleAccent: "Ftaklakis Media",
            titlePost: ".",
            intro: "Premium cinematic content that helps businesses grow through social media.",
            body: "Strategy, filming, editing and delivery — content built to attract attention and generate results.",
            servicesLabel: "What we do",
            services: [
                "Social Media Content",
                "Commercial Videos",
                "Drone Videography",
                "Podcast Production",
                "Video Editing",
            ],
            badge: "Ftaklakis Media",
            caption: "Athens · Worldwide",
            captionSub: "Premium Content Studio",
        },
        footer: {
            tagline:
                "Premium content that grows businesses. A Greek creative media studio directed by Kostas Ftaklakis.",
            studio: "Studio",
            follow: "Follow",
            location: "Athens · Greece",
            copyright: "All rights reserved",
            backToTop: "Back to top ↑",
            links: {
                industries: "Industries",
                services: "Services",
                pricing: "Monthly Plans",
                work: "Selected Work",
                contact: "Contact",
            },
        },
    },
    el: {
        nav: {
            industries: "Κλάδοι",
            services: "Υπηρεσίες",
            pricing: "Τιμές",
            work: "Έργα",
            contact: "Επικοινωνία",
            letsTalk: "Μιλήστε μας",
        },
        hero: {
            badge: "FTAKLAKIS MEDIA · Premium Content Studio",
            location: "Αθήνα · Παγκοσμίως",
            line1: "Premium περιεχόμενο",
            line2Pre: "που ",
            line2Accent: "αναπτύσσει",
            line3: "επιχειρήσεις.",
            subtitle: {
                pre: "Social media, podcasts, drone films και κινηματογραφικό βίντεο — από ",
                a: "ένα premium στούντιο",
                sep1: "",
                b: "",
                sep2: "",
                c: "",
                sep3: "",
                d: "",
                sep4: "",
                e: "",
                post: ".",
            },
            ctaPrimary: "Ξεκινήστε ένα project",
            ctaSecondary: "Δείτε το Portfolio",
            stats: [
                { k: "250+", v: "Παραγωγές Podcast" },
                { k: "Multi-Industry", v: "Δημιουργία Περιεχομένου" },
                { k: "4K", v: "Ποιότητα Κινηματογράφου" },
                { k: "Same-Day", v: "Απάντηση" },
            ],
        },
        marquee: [
            "ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΟ ΠΕΡΙΕΧΟΜΕΝΟ",
            "SOCIAL MEDIA",
            "DRONE FILMS",
            "ΠΑΡΑΓΩΓΗ PODCAST",
            "SHORT FORM ΠΕΡΙΕΧΟΜΕΝΟ",
            "BRAND STORYTELLING",
        ],
        ourServices: {
            eyebrow: "Οι Υπηρεσίες μας",
            titlePre: "Ό,τι χρειάζεστε για να ",
            titleAccent: "αναπτυχθείτε",
            titlePost: ", σε ένα στούντιο.",
            lede: "Έξι premium δυνατότητες παραγωγής — ενσωματωμένες σε ένα μηνιαίο σύστημα που κρατά το brand σας σταθερά ορατό και σταθερά premium.",
            explore: "Δείτε περισσότερα",
            cards: [
                {
                    title: "Διαχείριση Social Media",
                    body: "Στρατηγική, περιεχόμενο και δημοσίευση για την ανάπτυξη της παρουσίας σας και τη μετατροπή σε πελάτες.",
                },
                {
                    title: "Short Form Περιεχόμενο",
                    body: "Reels, TikToks και Shorts σχεδιασμένα για τον αλγόριθμο — μετατρέπουν το scroll σε ακολούθους.",
                },
                {
                    title: "Παραγωγή Podcast",
                    body: "Studio-grade multi-cam εκπομπές για κύρος — από concept έως διανομή.",
                },
                {
                    title: "Λήψεις με Drone",
                    body: "Πιστοποιημένη εναέρια κινηματογράφηση για φιλοξενία, real estate και premium brand films.",
                },
                {
                    title: "Εμπορική Παραγωγή Βίντεο",
                    body: "Πλήρης κινηματογραφική παραγωγή — από δημιουργική διεύθυνση έως γύρισμα και τελική παράδοση.",
                },
                {
                    title: "Επαγγελματικό Montage",
                    body: "Story-first montage με κινηματογραφικό χρώμα, sound design και motion — σε επίπεδο κινηματογράφου.",
                },
            ],
        },
        industries: {
            eyebrow: "Φτιαγμένο για την επιχείρησή σας",
            titlePre: "Περιεχόμενο που φέρνει ",
            titleAccent: "πραγματικούς πελάτες",
            titlePost: " στην πόρτα σας.",
            lede: "Εξειδικευόμαστε σε premium περιεχόμενο για τοπικές επιχειρήσεις που θέλουν να δείχνουν — και να πουλάνε — σαν διεθνή brand.",
            footerLead:
                "Δεν είστε στη λίστα; Συνεργαζόμαστε με premium brands από κάθε κλάδο.",
            footerCta: "Πείτε μας για την επιχείρησή σας →",
            cards: [
                {
                    title: "Ξενοδοχεία",
                    promise: "Περισσότερες απευθείας κρατήσεις.",
                    line: "Κινηματογραφικά videos ξενοδοχείων που μετατρέπουν το scroll σε διαμονή.",
                },
                {
                    title: "Εστιατόρια",
                    promise: "Γεμάτα τραπέζια, κάθε εβδομάδα.",
                    line: "Περιεχόμενο φαγητού και ατμόσφαιρας που γεμίζει κρατήσεις.",
                },
                {
                    title: "Γυμναστήρια & Studios",
                    promise: "Περισσότερες εγγραφές, λιγότερες απώλειες.",
                    line: "Reels γεμάτα ενέργεια που δείχνουν την κοινότητα και τα αποτελέσματά σας.",
                },
                {
                    title: "Real Estate",
                    promise: "Πιο γρήγορες πωλήσεις.",
                    line: "Ξεναγήσεις ακινήτων και drone videos που πουλάνε πριν την επίσκεψη.",
                },
                {
                    title: "Πολυτελείς Βίλες",
                    promise: "Premium επισκέπτες, premium τιμές.",
                    line: "Editorial films που τοποθετούν τη βίλα σας ως προορισμό.",
                },
                {
                    title: "Επαγγελματικές Υπηρεσίες",
                    promise: "Εμπιστοσύνη που μετατρέπει.",
                    line: "Κομψό περιεχόμενο για δικηγορικά γραφεία, λογιστικά γραφεία, συμβούλους, αρχιτέκτονες, οικονομικούς συμβούλους και ιδιωτικά γραφεία — χτίζοντας κύρος και εμπιστοσύνη πελατών.",
                },
            ],
            seePlans: "Δείτε τα πλάνα",
        },
        about: {
            eyebrow: "Το Στούντιο",
            titlePre: "Ένα premium στούντιο περιεχομένου, φτιαγμένο να κάνει brands την ",
            titleName: "",
            titleMid: "",
            titleAccent: "προφανή premium επιλογή",
            titlePost: ".",
            chapter: "Κεφάλαιο",
            chapters: [
                {
                    title: "Περιεχόμενο φτιαγμένο να πουλάει.",
                    body: "Κάθε βίντεο μετατρέπει την προσοχή σε κρατήσεις, εγγραφές και πωλήσεις.",
                },
                {
                    title: "Ένα brand που εμπνέει εμπιστοσύνη.",
                    body: "Η κινηματογραφική δουλειά μας υποδηλώνει ποιότητα — ώστε οι πελάτες να επιλέγουν εσάς πρώτα.",
                },
                {
                    title: "Ένα μηνιαίο σύστημα, όχι εφάπαξ δουλειά.",
                    body: "Λειτουργούμε ως ο πλήρης media συνεργάτης σας — σχεδιασμός, παραγωγή, παράδοση κάθε μήνα.",
                },
            ],
        },
        services: {
            eyebrow: "Υπηρεσίες · 05",
            titlePre: "Πέντε ειδικότητες. ",
            titleAccent: "Ένα στούντιο.",
            lede: "Κάθε υπηρεσία σχεδιάζεται ως το δικό της premium προϊόν — με σαφή τιμή, εύρος και παράδοση σε επίπεδο κινηματογραφικής παραγωγής.",
            seePlans: "Δείτε τα πλάνα",
            cards: [
                {
                    title: "Διαχείριση Social Media",
                    tag: "Παρουσία",
                    body: "Ένα μηνιαίο σύστημα που αναπτύσσει την παρουσία σας, τοποθετεί το brand και μετατρέπει την προσοχή σε πελάτες.",
                    deliverables: [
                        "Στρατηγική και άξονες περιεχομένου",
                        "Παραγωγή short-form",
                        "Δημοσίευση & κοινότητα",
                        "Μηνιαία αναφορά απόδοσης",
                    ],
                },
                {
                    title: "Παραγωγή Podcast",
                    tag: "Κύρος",
                    body: "Εκπομπές studio-grade φτιαγμένες για κύρος — από concept και multi-cam λήψη έως διανομή και social clips.",
                    deliverables: [
                        "Concept και σχεδιασμός φόρμας",
                        "Λήψη multi-cam στο studio",
                        "Πλήρες montage επεισοδίου + audio",
                        "Short-form cutdowns",
                    ],
                },
                {
                    title: "Επαγγελματικό Montage",
                    tag: "Τέχνη",
                    body: "Montage με στοιχεία αφήγησης, κινηματογραφικό color grade, sound design και motion τυπογραφία. Φτιαγμένο να κρατά την προσοχή από το πρώτο δευτερόλεπτο.",
                    deliverables: [
                        "Story-first cuts",
                        "Κινηματογραφικό color grade",
                        "Sound design & μουσική",
                        "Motion τυπογραφία",
                    ],
                },
                {
                    title: "Λήψεις με Drone",
                    tag: "Οπτική",
                    body: "Πιστοποιημένη εναέρια κινηματογράφηση για φιλοξενία, real estate και brand films. Κινηματογραφικό υψόμετρο, ελεγχόμενη ακρίβεια.",
                    deliverables: [
                        "Αναζήτηση τοποθεσίας",
                        "Πιστοποιημένος pilot & 4K cine",
                        "Παράδοση με color grade",
                        "Κάθετα & οριζόντια cuts",
                    ],
                },
                {
                    title: "Δημιουργία Organic Περιεχομένου",
                    tag: "Υπογραφή",
                    body: "Πλήρης κινηματογραφική παραγωγή — από δημιουργική διεύθυνση και προπαραγωγή έως γύρισμα και τελική παράδοση.",
                    deliverables: [
                        "Short-form Βίντεο",
                        "Long-form Βίντεο",
                        "Instagram Reels",
                        "TikTok Περιεχόμενο",
                        "YouTube Περιεχόμενο",
                        "Brand Storytelling",
                    ],
                },
            ],
        },
        why: {
            eyebrow: "Γιατί συνεργάζονται μαζί μας",
            titlePre: "Τέσσερις λόγοι που οι brands ",
            titleAccent: "μένουν μαζί μας",
            titlePost: ".",
            lede: "Δεν είμαστε marketing agency. Είμαστε συνεργάτης παραγωγής — εμμονικοί με την τέχνη, τη συνέπεια και τα αποτελέσματα.",
            cards: [
                {
                    title: "Premium Κινηματογραφικό Περιεχόμενο",
                    body: "Κάθε βίντεο σκηνοθετείται, γυρίζεται και παίρνει color grade σε επίπεδο κινηματογράφου. Περιεχόμενο που δείχνει άμεσα premium brand.",
                },
                {
                    title: "Γρήγορη Μηνιαία Παράδοση",
                    body: "Ένα αξιόπιστο σύστημα παραγωγής που παραδίδει εγκαίρως, κάθε μήνα — για να μη μένει ποτέ χωρίς καύσιμο το marketing σας.",
                },
                {
                    title: "Ανάπτυξη Social Media",
                    body: "Περιεχόμενο σχεδιασμένο για τον αλγόριθμο — short-form που μετατρέπει το scroll σε ακολούθους, κρατήσεις και πελάτες.",
                },
                {
                    title: "Μακροχρόνια Συνεργασία",
                    body: "Λειτουργούμε ως το εσωτερικό σας media team. Μία στρατηγική, μία φωνή, ένας συνεργάτης — για τη μακρά διαδρομή.",
                },
            ],
        },
        pricing: {
            eyebrow: "Business Social Media Management · 03",
            titlePre: "Πακέτα ",
            titleAccent: "Διαχείρισης Social Media",
            titlePost: " για Επιχειρήσεις.",
            lede: "Αυτά τα πακέτα σχεδιάζονται για επιχειρήσεις που θέλουν συνεπές μηνιαίο περιεχόμενο και ανάπτυξη social media. Κάθε άλλη υπηρεσία τιμολογείται προσαρμοσμένα με βάση τις απαιτήσεις του project.",
            perMonth: "/ μήνα",
            vat: "+ ΦΠΑ",
            plan: "Πλάνο",
            mostPopular: "Πιο δημοφιλές",
            custom: {
                eyebrow: "Κάθε άλλη υπηρεσία",
                titlePre: "Ζητήστε ",
                titleAccent: "Προσωποποιημένη Προσφορά",
                body: "Παραγωγή Podcast, Επαγγελματικό Montage, Λήψεις με Drone, High-End Εμπορική Παραγωγή Βίντεο, Στρατηγική Περιεχομένου, Προσωπικό Branding και Φωτογράφιση προσαρμόζονται και τιμολογούνται αποκλειστικά με βάση τις απαιτήσεις σας.",
                servicesLabel: "Υπηρεσίες με custom προσφορά",
                services: [
                    "Παραγωγή Podcast",
                    "Επαγγελματικό Montage",
                    "Λήψεις με Drone",
                    "High-End Εμπορική Παραγωγή Βίντεο",
                    "Στρατηγική Περιεχομένου",
                    "Προσωπικό Branding",
                    "Φωτογράφιση",
                ],
                cta: "Κλείστε Discovery Call",
            },
            plans: [
                {
                    name: "Starter",
                    tag: "Για νέα brands",
                    videos: "15 Βίντεο",
                    features: [
                        "15 short-form βίντεο ανά μήνα",
                        "Πλήρες montage & sound design",
                        "Κινηματογραφικό color grade",
                        "Έτοιμα για Reels, TikTok, Shorts",
                        "Μηνιαία αναφορά απόδοσης",
                    ],
                    cta: "Ξεκινήστε με Starter",
                },
                {
                    name: "Growth",
                    tag: "Πιο δημοφιλές",
                    videos: "30 Βίντεο",
                    features: [
                        "30 short-form βίντεο ανά μήνα",
                        "Προτεραιότητα στην παραγωγή",
                        "Προχωρημένο montage & motion",
                        "Στρατηγική και άξονες περιεχομένου",
                        "Κλήση αξιολόγησης ανά 15 μέρες",
                    ],
                    cta: "Επιλέξτε Growth",
                },
                {
                    name: "Scale",
                    tag: "Για σοβαρά brands",
                    videos: "90 Βίντεο",
                    bonus: "Περιλαμβάνει 30 bonus βίντεο",
                    is3Month: true,
                    periodNote: "3μηνο πακέτο",
                    features: [
                        "90 short-form βίντεο ανά μήνα",
                        "Περιλαμβάνει 30 bonus βίντεο",
                        "Αποκλειστικός editor & παραγωγός",
                        "Πλήρες σύστημα και ημερολόγιο περιεχομένου",
                        "Εβδομαδιαία κλήση στρατηγικής",
                    ],
                    cta: "Κάντε Scale μαζί μας",
                },
            ],
        },
        portfolio: {
            eyebrow: "Επιλεγμένα Έργα",
            titlePre: "Πρόσφατα ",
            titleAccent: "films",
            titlePost: ".",
            cta: "Ξεκινήστε ένα project",
            uploadMedia: "Ανεβάστε Media",
            editableNote: {
                title: "Περισσότερα έργα σύντομα",
                body: "Νέα client projects, παραγωγές podcast, drone footage και κινηματογραφικά brand films — προστίθενται όσο ολοκληρώνονται.",
            },
            categories: {
                All: "Όλα",
                Podcast: "Podcast",
                Drone: "Drone",
                Business: "Επιχείρηση",
            },
            items: {
                "podcast-photo": {
                    title: "Podcast · Φωτογραφία",
                    meta: "Studio φωτογράφιση · Σύντομα",
                },
                "drone-footage": {
                    title: "Hospitality Aerial Film",
                    meta: "Drone · 4K · Κινηματογραφικό",
                },
                "business-video": {
                    title: "Retail Brand Film",
                    meta: "Commercial · Brand Storytelling",
                },
            },
        },
        cta: {
            eyebrow: "Είμαστε έτοιμοι όποτε είστε",
            titlePre: "Ας ",
            titleAccent: "αναπτύξουμε",
            titlePost: " το brand σας",
            sub: {
                pre: "Premium περιεχόμενο που φέρνει ",
                a: "προσοχή",
                sep1: ", ",
                b: "εμπιστοσύνη",
                and: " και ",
                c: "πελάτες",
                post: ".",
            },
            primary: "Ξεκινήστε ένα project",
            secondary: "Δείτε τα πλάνα",
            location: "Δεχόμαστε επιλεγμένα projects · Αθήνα · Παγκοσμίως",
        },
        contact: {
            eyebrow: "Επικοινωνία · Διαθέσιμοι Τώρα",
            titlePre: "Ας ",
            titleAccent: "μιλήσουμε",
            subtitle: {
                pre: "Είτε είστε ",
                a: "εστιατόριο",
                sep1: ", ",
                b: "ξενοδοχείο",
                sep2: ", ",
                c: "γυμναστήριο",
                sep3: ", ",
                d: "μεσιτικό γραφείο",
                and: " ή ",
                e: "τοπική επιχείρηση",
                post: " — δημιουργούμε premium περιεχόμενο που σας βοηθά να προσελκύσετε περισσότερους πελάτες.",
            },
            labels: {
                direct: "Απευθείας",
                based: "Έδρα",
                response: "Απάντηση",
                location: "Αθήνα · Ελλάδα",
                worldwide: "Δραστηριοποίηση παγκοσμίως",
                within: "Αυθημερόν",
            },
            channels: {
                WhatsApp: "WhatsApp",
                Email: "Email",
                Instagram: "Instagram",
                YouTube: "YouTube",
                TikTok: "TikTok",
                Facebook: "Facebook",
                LinkedIn: "LinkedIn",
                Viber: "Viber",
            },
        },
        follow: {
            eyebrow: "Ακολουθήστε με",
            titlePre: "Μείνετε κοντά στο ",
            titleAccent: "στούντιο",
            titlePost: ".",
            lede: "Στιγμιότυπα από τα παρασκήνια, νέες κυκλοφορίες και κινηματογραφικές στιγμές — απευθείας από το studio.",
        },
        speaking: {
            eyebrow: "Γνωρίστε την Ftaklakis Media",
            titlePre: "Γνωρίστε την ",
            titleAccent: "Ftaklakis Media",
            titlePost: ".",
            intro: "Δημιουργούμε premium κινηματογραφικό περιεχόμενο που βοηθά επιχειρήσεις να αναπτυχθούν μέσω social media.",
            body: "Από τη στρατηγική έως το γύρισμα, το montage και την παράδοση, παράγουμε περιεχόμενο σχεδιασμένο να προσελκύει την προσοχή και να φέρνει αποτελέσματα.",
            servicesLabel: "Τι κάνουμε",
            services: [
                "Social Media Περιεχόμενο",
                "Εμπορικά Βίντεο",
                "Λήψεις με Drone",
                "Παραγωγή Podcast",
                "Επαγγελματικό Montage",
            ],
            badge: "Ftaklakis Media",
            caption: "Αθήνα · Παγκοσμίως",
            captionSub: "Premium Content Studio",
        },
        footer: {
            tagline:
                "Premium περιεχόμενο που αναπτύσσει επιχειρήσεις. Ένα ελληνικό δημιουργικό στούντιο μέσων υπό τη διεύθυνση του Κώστα Φτακλάκη.",
            studio: "Στούντιο",
            follow: "Ακολουθήστε",
            location: "Αθήνα · Ελλάδα",
            copyright: "Όλα τα δικαιώματα διατηρούνται",
            backToTop: "Πίσω στην αρχή ↑",
            links: {
                industries: "Κλάδοι",
                services: "Υπηρεσίες",
                pricing: "Μηνιαία Πλάνα",
                work: "Επιλεγμένα Έργα",
                contact: "Επικοινωνία",
            },
        },
    },
};
